<template>
  <q-page padding>
    <PageHeader
      title="Criar novo Grupo"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-gutter-sm items-center text-brand-5 text-weight-bold q-mt-md"
    >
      <div class="col-md-2 col-xs-6">
        <div class="titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="titulo-input">Nome do Grupo</div>
        <q-input
          class="input-mobile"
          dense
          outlined
          v-model="dados.nomeGrupo"
        />
      </div>
      <div class="col-md-4 col-xs-6">
        <div class="titulo-input">Descrição</div>
        <q-input
          class="input-mobile"
          dense
          outlined
          v-model="dados.descricaoGrupo"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          color="positive"
          class="q-mt-xs btn"
          label="Criar"
          icon="add"
          no-caps
          @click="criarGrupo()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Grupos Criados
        </div>
        <div class="row col-md-3 col-xs-12 justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md col-xs-7 input-mobile"
            placeholder="Pesquisar"
            v-model="dados.filtroNome"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        :columns="columns"
        :rows="listaGruposCriados"
        :hide-bottom="!listaGruposCriados.length == 0"
        selection="single"
        v-model:selected="selected"
        row-key="catalogoGrupoUuid"
        no-data-label="Nenhum grupo criado"
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Nome:</strong>
                      <span v-if="!props.selected"> {{ props.row.nome }}</span>
                      <input
                        v-else
                        v-model="props.row.nome"
                        class="input-mobile-grid row col-12"
                      />
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs q-mt-xs">Descrição:</strong>
                      <span v-if="!props.selected">
                        {{ props.row.descricao }}</span
                      >
                      <input
                        v-else
                        v-model="props.row.descricao"
                        class="input-mobile-grid row col-12"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end no-wrap">
                      <div>
                        <router-link
                          :to="{
                            name: 'ferramentaria-detalhe-grupo',
                            params: {
                              grupoId: props?.row?.catalogoGrupoUuid,
                            },
                          }"
                        >
                          <q-btn color="secondary" icon="article" round flat />
                        </router-link>
                        <q-btn
                          v-if="!props.selected"
                          icon="edit"
                          flat
                          color="primary"
                          :disable="disable"
                          @click="
                            (props.selected = true),
                              (dadoEditarGrupo = { ...props.row })
                          "
                        />
                        <q-btn
                          v-else
                          icon="done"
                          flat
                          round
                          color="positive"
                          :disable="disable"
                          @click="editarGrupo(props.row)"
                        />
                      </div>
                      <div>
                        <q-btn
                          icon="delete"
                          flat
                          color="red"
                          :disable="disable"
                          @click="excluirGrupo(props.row.catalogoGrupoUuid)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              <span v-if="!props.selected">{{ props.row.nome }}</span>
              <q-input
                class="input"
                v-else
                dense
                outlined
                v-model="props.row.nome"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected"> {{ props.row.descricao }}</span>
              <q-input
                class="input"
                v-else
                dense
                outlined
                v-model="props.row.descricao"
              />
            </q-td>
            <q-td class="coluna-btn">
              <router-link
                :to="{
                  name: 'ferramentaria-detalhe-grupo',
                  params: {
                    grupoId: props?.row?.catalogoGrupoUuid,
                  },
                }"
              >
                <q-btn color="secondary" icon="article" round flat />
              </router-link>
            </q-td>
            <q-td class="coluna-btn">
              <q-btn
                v-if="!props.selected"
                color="primary"
                icon="edit"
                round
                flat
                :disable="disable"
                @click="
                  (props.selected = true), (dadoEditarGrupo = { ...props.row })
                "
              />
              <q-btn
                v-else
                color="positive"
                icon="done"
                round
                flat
                :disable="disable"
                @click="editarGrupo(props.row)"
              />
            </q-td>
            <q-td class="coluna-btn">
              <q-btn
                color="red"
                icon="delete"
                round
                flat
                :disable="disable"
                @click="excluirGrupo(props.row.catalogoGrupoUuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="listaGruposCriados.length > 0"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "nomeGrupo",
    label: "Nome do Grupo",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const catalogoUuid = salvarCatalogoUuid();
    let rightDrawerModalOpen = ref(false);
    const listaGruposCriados = ref([]);
    const selected = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    const dados = ref({
      nomeGrupo: "",
      descricaoGrupo: "",
      filtroNome: "",
    });
    const dadoEditarGrupo = ref();
    let loading = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarGruposCriados = async (page = 1, rowsPerPage = 10) => {
      await store.state.org.unidadeData.id;
      if (catalogoUuid.catalogoUuid.value === null) {
        listaGruposCriados.value = [];
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarGruposCriados",
          {
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            unidadeId: store.state.org.unidadeData.id,
            nome: dados.value.filtroNome,
            page: page,
            per_page: mobile.value ? 5 : rowsPerPage,
          }
        );
        listaGruposCriados.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const criarGrupo = async () => {
      if (dados.value.nomeGrupo === "") {
        quasar.notify({
          message: "O nome do grupo é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value.descricaoGrupo === "") {
        quasar.notify({
          message: "A descrição do grupo é obrigatória.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("ferramentaria/criarGrupo", {
          unidadeId: store.state.org.unidadeData.id,
          catalogoUuid: store.state.ferramentaria.catalogoUuid,
          nome: dados.value.nomeGrupo,
          descricao: dados.value.descricaoGrupo,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        quasar.notify({
          message: "Grupo criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetVariaveis();
        listarGruposCriados();
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarGrupo = async (grupo) => {
      if (grupo.nome === "") {
        quasar.notify({
          message: "O nome do grupo é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (grupo.descricao === "") {
        quasar.notify({
          message: "A descrição do grupo é obrigatória.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        grupo.nome === dadoEditarGrupo.value.nome &&
        grupo.descricao === dadoEditarGrupo.value.descricao
      ) {
        selected.value = [];
        return;
      }

      try {
        await store.dispatch("ferramentaria/editarGrupo", {
          catalogoGrupoUuid: grupo.catalogoGrupoUuid,
          nome: grupo.nome,
          descricao: grupo.descricao,
        });
        quasar.notify({
          message: "Grupo editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarGruposCriados();
        selected.value = [];
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetVariaveis = () => {
      dados.value = {
        nomeGrupo: "",
        descricaoGrupo: "",
        filtroNome: "",
      };
    };

    watch(
      () => pagination.value.page,
      () => {
        listarGruposCriados(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    const excluirGrupo = async (catalogoGrupoUuid) => {
      try {
        await store.dispatch("ferramentaria/deletarGrupo", {
          catalogoGrupoUuid,
        });
        quasar.notify({
          message: "Grupo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarGruposCriados();
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      [() => catalogoUuid.catalogoUuid.value, () => dados.value.filtroNome],
      () => {
        listarGruposCriados();
      }
    );

    onMounted(() => {
      listarGruposCriados();
    });

    return {
      columns,
      rightDrawerModalOpen,
      listarGruposCriados,
      listaGruposCriados,
      selected,
      pagination,
      mobile,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      dados,
      criarGrupo,
      resetVariaveis,
      editarGrupo,
      dadoEditarGrupo,
      loading,
      excluirGrupo,
      catalogoUuid,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-input {
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
  }
  .input-mobile {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .input-mobile-grid {
    width: 100%;
    outline: none;
  }
}
</style>
